import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'

// Dynamically imported so vanilla-cookieconsent (and its CSS) ships as its
// own chunk instead of bloating the main bundle every visitor downloads
// upfront — the banner isn't needed for first paint.
import('./lib/consent').then(({ initConsent }) => initConsent());

const container = document.getElementById("root")!;

const tree = (
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <App />
  </BrowserRouter>
);

// The production build prerenders each route into #root (see
// scripts/prerender.mjs), so hydrate when markup is already there and fall back
// to a plain client render otherwise (e.g. `vite dev`).
if (container.firstElementChild) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
